import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sbd-account-portal-frontend-drawer-breadcrumb',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './drawer-breadcrumb.component.html',
})
export class DrawerBreadcrumbComponent {
  @Input() titles: string[] = [];
  @Input() position: number = 1;
}
